import $ from 'jquery';

$.fn.dataTable.ext.buttons.reload = {
	name: 'reload',
	className: 'buttons-reload',
	text: function (dt) {
		return dt.i18n('buttons.reload', 'Reload');
	},
	action: function (e, dt, node, config) {
		dt.ajax.reload(null, true);
	}
};


// WEBPACK FOOTER //
// ./node_modules/linksoft-datatables/src/buttons/reload.js